import React, { useState } from "react";
import { CAProvinces, stateList } from "../../../util/CommonLists";
import { PATTERNS } from "../../../util/patterns";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import { GetCountryListAndInternationalSupport } from "../../../util/countryListAndInternationalSupport";
import { useTranslation } from "react-i18next";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";

interface IProps {
    register: any;
    errors: any;
    billingState: any;
    setBillingState: any;
    registrationState: any;
    handleStateChange?: (e: any) => void;
    displayData: any;
}

const BillingAddress = ({ register, errors, billingState, setBillingState, registrationState, handleStateChange, displayData }: IProps) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const { supportInternational } = GetCountryListAndInternationalSupport();
    const [zipCode, setZipCode] = useState(i18nService.get("ZipCode"));
    const pattern: string = i18nService.get("ZipCode.Pattern");

    const checked = () => {
        if (billingState.isSameAddress) {
            setBillingState({ ...billingState, isSameAddress: false });
            return;
        }
        setBillingState({ ...billingState, isSameAddress: true });
    };

    return (
        <>
            <div className="box-header">
                <div className="box-title-container" style={{ marginTop: "25px" }}>
                    <div className="box-title-icon" aria-hidden="true">
                        <RenderIcons iconName="map-marker" />
                    </div>
                    <div className="box-title-text">
                        <h2 className="box-title">{tLang("registration.billing.address.title")}</h2>
                    </div>
                </div>
            </div>
            <div className="box-content">
                <div className="row between-sm">
                    <div className="col-xs-12 col-sm-12 col-no-gutter">
                        <fieldset className="form-row inline">
                            <div className="row">
                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="form-row">
                                        <div className="form-input">
                                            <label className="form-checkbox-label" htmlFor="isSame">
                                                <input type="checkbox" id="isSame" name="isSame" onChange={() => checked()} checked={billingState.isSameAddress} />
                                                <span className="form-checkbox-label-text">{tLang("registration.billing.address.same")}</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>

                        <div className="margin-bottom-l"></div>

                        {!billingState.isSameAddress && (
                            <div>
                                <fieldset className="form-row inline">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <legend className="legend-label">     <label htmlFor="label-address-line-1">{tLang("registration.billing.address.street")}</label>
                                            <span className="required" title="Mandatory">
                                                            {" "}
                                                            *
                                                        </span>
                                            </legend>
                                        </div>

                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div className={`form-row row ${errors["address1"] && "status-error"}`}>
                                                <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                    <label htmlFor="label-address-line11">{tLang("registration.billing.address.address-1")}</label>
                                                </div>
                                                <div className="form-input col-xs-12 col-no-gutter">
                                                    <input
                                                        type="text"
                                                        name="address1"
                                                        className="inputbox"
                                                        id="label-address-line-1"
                                                        ref={register({ required: true, pattern: PATTERNS.STREETADDRESS.pattern })}
                                                        placeholder={tLang("registration.billing.address.address-1")}
                                                        defaultValue={registrationState.billingInfo && registrationState.billingInfo.address1}
                                                        aria-required="true"
                                                    />
                                                    {errors["address1"] && errors["address1"].type === "required" && (
                                                        <span className="form-error" role='alert'>{tLang("registration.billing.address.validations.address1.required")}</span>
                                                    )}
                                                    {errors["address1"] && errors["address1"].type === "pattern" && (
                                                        <span className="form-error" role='alert'>{tLang("registration.billing.address.validations.address1.pattern")}</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className={`form-row row ${errors["address2"] && "status-error"}`}>
                                                <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                    <label htmlFor="label-address-line-2">{tLang("registration.billing.address.address-2")}</label>
                                                </div>
                                                <div className="form-input col-xs-12 col-no-gutter">
                                                    <input
                                                        type="text"
                                                        name="address2"
                                                        className="inputbox"
                                                        id="label-address-line-2"
                                                        ref={register({ pattern: PATTERNS.STREETADDRESS.pattern })}
                                                        placeholder={tLang("registration.billing.address.address-2")}
                                                        defaultValue={registrationState.billingInfo && registrationState.billingInfo.address2}
                                                    />
                                                    {errors["address2"] && errors["address2"].type === "pattern" && (
                                                        <span className="form-error" role='alert'>{tLang("registration.billing.address.validations.address2.pattern")}</span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>

                                <fieldset className="form-row inline">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <legend className="legend-label"> <label htmlFor="label-address-city">{tLang("registration.billing.address.city")}</label>
                                                <span className="required" title="Mandatory">
                                                    {" "}
                                                    *
                                                </span>
                                            </legend>
                                        </div>

                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div className="row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className={`form-row row ${errors["city"] && "status-error"}`}>
                                                        <div className="form-input col-xs-12 col-no-gutter">
                                                            <input
                                                                type="text"
                                                                name="city"
                                                                className="inputbox"
                                                                id="label-address-city"
                                                                ref={register({ required: true, pattern: PATTERNS.CITY.pattern })}
                                                                placeholder={tLang("registration.billing.address.city")}
                                                                defaultValue={registrationState.billingInfo && registrationState.billingInfo.city}
                                                                aria-required="true"
                                                            />
                                                            {errors["city"] && errors["city"].type === "required" && (
                                                                <span className="form-error" role='alert'>
                                                                    {tLang("registration.billing.address.validations.city.required")}
                                                                </span>
                                                            )}
                                                            {errors["city"] && errors["city"].type === "pattern" && (
                                                                <span className="form-error" role='alert'>{tLang("registration.billing.address.validations.city.pattern")}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>

                                <fieldset className="form-row inline">
                                    <div className="row">
                                        {registrationState.addressInfo.country === "US" || !supportInternational ? (
                                            <div className={`form-row inline row ${errors["state"] && "status-error"}`}>
                                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                    <label htmlFor="label-address-state">{tLang("registration.billing.address.state")}
                                                        <span className="required" title="Mandatory">
                                                            {" "}
                                                            *
                                                        </span>
                                                    </label>
                                                </div>

                                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                                    <select
                                                        className="inputbox"
                                                        id="label-address-state"
                                                        name="state"
                                                        defaultValue={
                                                            Object.keys(registrationState.billingInfo).length !== 0 ? registrationState.billingInfo.state : ""
                                                        }
                                                        ref={register({ required: true, validate: (value: any) => value !== "---" })}
                                                        onChange={(e: any) => {
                                                            if (handleStateChange) {
                                                                handleStateChange(e);
                                                            }
                                                        }}
                                                        aria-required="true"
                                                    >
                                                        {stateList.map((val: any) => (
                                                            <option key={val.name} value={val.value}>
                                                                {val.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {errors["state"] && errors["state"].type === "validate" && (
                                                        <span className="form-error" role='alert'>{tLang("registration.billing.address.validations.state.required")}</span>
                                                    )}
                                                </div>
                                            </div>
                                        ) : registrationState.addressInfo.country === "CA" ? (
                                            <div className={`form-row inline row ${errors["state"] && "status-error"}`}>
                                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                    <label htmlFor="label-address-state">Province</label>
                                                </div>
                                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                                    <select
                                                        className="inputbox"
                                                        id="label-address-state"
                                                        defaultValue={
                                                            Object.keys(registrationState.billingInfo).length !== 0 ? registrationState.billingInfo.state : ""
                                                        }
                                                        name="state"
                                                        ref={register({ required: true, validate: (value: any) => value !== "---" })}
                                                    >
                                                        {CAProvinces.map((val: any) => (
                                                            <option key={val.name} value={val.value}>
                                                                {val.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {errors["state"] && errors["state"].type === "validate" && (
                                                            <span className="form-error" role='alert'>
                                                            {tLang("registration.personalInfo2Widget.validationMessage.province.required")}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        ) : (
                                            <div className={`form-row inline row ${errors["state"] && "status-error"}`}>
                                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                    <label htmlFor="label-address-state">Region</label>
                                                </div>
                                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                                    <input
                                                        type="text"
                                                        name="state"
                                                        defaultValue={
                                                            Object.keys(registrationState.billingInfo).length !== 0 ? registrationState.billingInfo.state : ""
                                                        }
                                                        ref={register({ required: true })}
                                                        className="inputbox"
                                                        id="label-address-state"
                                                    />
                                                    {errors["state"] && errors["state"].type === "required" && (
                                                     <span className="form-error" role='alert'>Region is required.</span>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </fieldset>

                                <fieldset className="form-row inline">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <legend className="legend-label"><label htmlFor="label-address-zipcode">{tLang("registration.billing.address.zip")}</label>
                                                <span className="required" title="Mandatory">
                                                    {" "}
                                                    *
                                                </span>
                                            </legend>
                                        </div>

                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div className="row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className={`form-row row ${errors["zipcode"] && "status-error"}`}>
                                                        <div className="form-input col-xs-12 col-no-gutter">
                                                            <input
                                                                type="text"
                                                                name="zipcode"
                                                                className="inputbox"
                                                                id="label-address-zipcode"
                                                                ref={register({ required: true, pattern: PATTERNS[pattern].pattern, maxLength: zipCode.MaxLength })}
                                                                placeholder={tLang("registration.billing.address.zip")}
                                                                defaultValue={registrationState.billingInfo && registrationState.billingInfo.zipcode}
                                                                aria-required="true"
                                                            />
                                                            {errors["zipcode"] && errors["zipcode"].type === "required" && (
                                                                <span className="form-error" role='alert'>
                                                                    {tLang("registration.billing.address.validations.zipCode.required")}
                                                                </span>
                                                            )}
                                                            {errors["zipcode"] && errors["zipcode"].type === "pattern" && (
                                                                <span className="form-error" role='alert'>
                                                                    {tLang("registration.billing.address.validations.zipCode.pattern")}
                                                                </span>
                                                            )}
                                                            {errors["zipcode"] && errors["zipcode"].type === "maxLength" && (
                                                                <span className="form-error" role='alert'>
                                                                    {zipCode.Label === "Zip Code"
                                                                        ? tLang("registration.billing.address.validations.zipCode.patternLength")
                                                                        : tLang("registration.billing.address.validations.postalCode.pattern")}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        )}

                        {errors["billingAddress"] && errors["billingAddress"].type === "required" && (
                            <fieldset className="form-row inline">
                                <div className="row">
                                    <div className="col-xs-12 col-sm-4 col-no-gutter"></div>
                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <span className="form-error" role='alert'>{tLang("registration.billing.address.validations.billingCommonMessage")}</span>
                                    </div>
                                </div>
                            </fieldset>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default BillingAddress;
